<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h1 class="book-title"><a id="page_iii"></a>Final Exam</h1>
<p class="linespace"> </p>
<p class="author">Maggie Barbieri</p>
<p class="linespace"> </p>
<p class="editor"><img alt="Image" src="images/pub.gif"/>   Minotaur Books  <img alt="Image" src="images/pub1.gif"/>  New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1818e6a2